export default __webpack_public_path__ + "static/media/sticker-o.6ac45136.png";